import { giphyBlue, giphyIndigo, giphyPink, giphyPurple } from '@giphy/js-brand'
import CreationToolWelcomeButton from './welcome-button'

enum CreationTool {
    Backdrop = 'CT_BACKDROP',
    GifMaker = 'CT_GIF_MAKER',
    Upload = 'CT_UPLOAD',
}

namespace CreationTool {
    /**
     * Returns the tool's tag added to all uploads.
     */
    export function uploadTag(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.Backdrop:
                return 'giphybackdropmaker'
            case CreationTool.GifMaker:
                return 'giphygifmaker'
            case CreationTool.Upload:
                return 'giphyupload'
        }
    }

    /**
     * Returns the tool's title.
     */
    export function title(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.Backdrop:
                return 'Backdrop'
            case CreationTool.GifMaker:
                return 'Create'
            case CreationTool.Upload:
                return 'Upload'
        }
    }

    /**
     * Returns the tool's description.
     */
    export function description(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.Backdrop:
                return 'Make any video conference far more fun by creating your own Backdrop! Begin by uploading a background or choosing one of our starters.'
            case CreationTool.GifMaker:
                return 'Create GIFs and backdrops and decorate them with captions, filters, stickers, and more.'
            case CreationTool.Upload:
                return 'Upload your GIF collection to share on Facebook, Twitter, Instagram, text message, email, & everywhere else.'
        }
    }

    /**
     * Returns the tool's gradient colors.
     */
    export function gradient(tool: CreationTool): string[] {
        switch (tool) {
            case CreationTool.Backdrop:
                return [giphyIndigo, giphyPurple]
            case CreationTool.GifMaker:
                return [giphyPink, giphyIndigo]
            case CreationTool.Upload:
                return [giphyIndigo, giphyBlue]
        }
    }

    /**
     * Returns the tool's welcome screen buttons.
     */
    export function welcomeButtons(tool: CreationTool): CreationToolWelcomeButton[] {
        switch (tool) {
            case CreationTool.GifMaker:
                return [
                    CreationToolWelcomeButton.Gif,
                    CreationToolWelcomeButton.Sticker,
                    CreationToolWelcomeButton.Backdrop,
                ]
            default:
                return []
        }
    }

    /**
     * Returns the tool's welcome screen peeker sticker url.
     */
    export function peekerUrl(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.GifMaker:
                return '/static/img/creation_tools/gif-maker-peeker.gif'
            default:
                return ''
        }
    }

    /**
     * Returns the tool's welcome screen background video url.
     */
    export function backgroundVideoUrl(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.GifMaker:
                return '/static/img/videos/9rv8tcpftaJcBDLamd.mp4'
            default:
                return ''
        }
    }

    /**
     * Returns the endpoint prop for suggested tags.
     */
    export function suggestedTagsEndpoint(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.GifMaker:
                return 'gif_maker'
            case CreationTool.Upload:
                return 'upload'
            default:
                return ''
        }
    }

    /**
     * Returns whether or not the tool requires user to be logged in.
     */
    export function requiresLogin(tool: CreationTool): boolean {
        switch (tool) {
            case CreationTool.GifMaker:
            case CreationTool.Upload:
                return true
            default:
                return false
        }
    }

    /**
     * Returns the tool's upload creation_location prefix.
     */
    export function creationLocationPrefix(tool: CreationTool): string {
        switch (tool) {
            case CreationTool.GifMaker:
                return 'desktopweb_gifmaker_create'
            case CreationTool.Upload:
                return 'desktopweb_uploadtool_upload'
            case CreationTool.Backdrop:
                return 'desktopweb_backdrop_create'
        }
    }
}

export default CreationTool
